import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';
import { AuthenticationService } from 'app/auth/service';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  // Public
  public coreConfig: any;
  public passwordTextType: boolean;
  public confPasswordTextType: boolean;
  public submitted: boolean = false;
  public loading: boolean = false;
  public form: FormGroup = new FormGroup({
    newPassword: new FormControl(null, [Validators.required]),
    confirmPassword: new FormControl(null, [Validators.required])
  }, {
    validators: this.password.bind(this)
  });
  public error = null;
  public message = null;
  public userId = '';
  public otpId = '';

  // Private
  private _unsubscribeAll: Subject<any>;

  constructor(
    private _coreConfigService: CoreConfigService,
    private _authenticationService: AuthenticationService,
    private _router: ActivatedRoute
  ) { 
    this._unsubscribeAll = new Subject();
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  ngOnInit(): void {
    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });

    this._router.queryParams.filter(params => params.userId).subscribe(params => {
      this.userId = params.userId;
      this.otpId = params.otpId;
    });
  }

  /**
   * Toggle password
   */
   togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  /**
   * Toggle confirm password
   */
  toggleConfPasswordTextType() {
    this.confPasswordTextType = !this.confPasswordTextType;
  }

  /**
   * On Submit
   */
   onSubmit() {
    this.submitted = true;
    this.error = null;
    this.message = null;
    // stop here if form is invalid
    if (this.form.invalid) {
      if(this.form.errors?.passwordNotMatch){
        this.error = 'Password not match';
      }
      return;
    }

    // Login
    this.loading = true;
    this._authenticationService
      .updatePassword(this.f.newPassword.value, this.userId, this.otpId)
      .pipe(first())
      .subscribe(
        data => {
          this.error = '';
          const { code , message} = data || {};
          if(code === 1001) {
            this.message = message;
            setTimeout(() => {
              this.message = null;
            }, 3000);
            this.loading = false;
            this.submitted = false;
            this.form.reset();
          } 
          else {
            this.loading = false;
            this.error = message
            setTimeout(() => {
              this.error = null;
            }, 3000);
          }
        },
        error => {
          this.error = error;
          this.loading = false;
          setTimeout(() => {
            this.error = null;
          }, 3000);
        }
      );
  }


  password(formGroup: FormGroup) {
    const { value: password } = formGroup.get('newPassword');
    const { value: confirmPassword } = formGroup.get('confirmPassword');
    return password === confirmPassword ? null : { passwordNotMatch: true };
  }

}
